import React, { useEffect, useState } from 'react';
import { Clock, Users, ArrowRight, Images } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';
import api from '../lib/api';
import { Link } from 'react-router-dom';
import Lightbox from './Lightbox';
import ExcursionBookingDialog from './ExcursionBookingDialog';

const ExcursionsSection = () => {
  const { t, lang } = useLanguage();
  const [items, setItems] = useState([]);
  const [lbOpen, setLbOpen] = useState(false);
  const [lbImages, setLbImages] = useState([]);
  const [bookExc, setBookExc] = useState(null);

  useEffect(() => {
    api.get('/excursions').then(r => setItems(r.data.filter(e => e.featured).slice(0, 6))).catch(() => {});
  }, []);

  const handleReserve = (exc) => {
    setBookExc(exc);
  };

  const openGallery = (exc) => {
    const imgs = exc.gallery && exc.gallery.length ? exc.gallery : (exc.image ? [exc.image] : []);
    setLbImages(imgs);
    setLbOpen(true);
  };

  return (
    <section id="excursions" className="py-24 bg-gradient-to-b from-[#0a0a0a] to-[#0f0f0f]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <span className="text-[#ff6b1a] text-sm font-bold tracking-[0.2em] uppercase">{t.excursions.tag}</span>
          <h2 className="text-4xl md:text-5xl font-black text-white mt-3 mb-4">{t.excursions.title}</h2>
          <p className="text-white/60 max-w-3xl mx-auto text-lg">{t.excursions.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-7">
          {items.map((exc) => {
            const galleryCount = (exc.gallery && exc.gallery.length) || (exc.image ? 1 : 0);
            return (
            <div key={exc.id} className="glass-card rounded-xl overflow-hidden card-hover group">
              <div className="relative h-56 overflow-hidden cursor-pointer" onClick={() => galleryCount > 0 && openGallery(exc)}>
                <img src={exc.image} alt={exc.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700" />
                <div className="absolute top-4 right-4 bg-[#ff6b1a] text-white px-4 py-1.5 rounded-full font-bold text-sm shadow-lg">
                  ${exc.price.toFixed(0)} USD
                </div>
                {galleryCount > 1 && (
                  <div className="absolute bottom-3 left-3 bg-black/70 backdrop-blur text-white px-2.5 py-1 rounded-md text-xs font-semibold flex items-center gap-1.5">
                    <Images className="w-3.5 h-3.5 text-[#ff6b1a]" /> {galleryCount} fotos
                  </div>
                )}
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-3">{lang === 'en' && exc.title_en ? exc.title_en : exc.title}</h3>
                <p className="text-white/60 text-sm leading-relaxed mb-5 line-clamp-3">{lang === 'en' && exc.description_en ? exc.description_en : exc.description}</p>
                <div className="flex items-center gap-4 text-xs text-white/50 mb-5">
                  <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5 text-[#ff6b1a]" /> {lang === 'en' && exc.duration_en ? exc.duration_en : exc.duration}</span>
                  <span className="flex items-center gap-1"><Users className="w-3.5 h-3.5 text-[#ff6b1a]" /> {t.excursions.groups}</span>
                </div>
                <Button onClick={() => handleReserve(exc)} className="btn-orange border-0 w-full rounded-md gap-2">
                  {t.excursions.reserve} <ArrowRight className="w-4 h-4" />
                </Button>
              </div>
            </div>
          );})}
        </div>

        <div className="text-center mt-12">
          <Link to="/excursiones">
            <Button variant="outline" className="border-[#ff6b1a] text-[#ff6b1a] hover:bg-[#ff6b1a] hover:text-white rounded-md">
              {t.excursions.viewAll}
            </Button>
          </Link>
        </div>
      </div>
      <Lightbox open={lbOpen} onClose={() => setLbOpen(false)} images={lbImages} />
      <ExcursionBookingDialog excursion={bookExc} open={!!bookExc} onOpenChange={(v) => !v && setBookExc(null)} />
    </section>
  );
};

export default ExcursionsSection;
